import { render, staticRenderFns } from "./Drawing.vue?vue&type=template&id=505d6912&scoped=true&"
import script from "./Drawing.vue?vue&type=script&lang=ts&"
export * from "./Drawing.vue?vue&type=script&lang=ts&"
import style0 from "./Drawing.vue?vue&type=style&index=0&id=505d6912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d6912",
  null
  
)

export default component.exports